import { withSentryRouting } from "@sentry/react";
import { Route } from "@talentpair/routing";

export const SentryRoute = withSentryRouting(Route);
